import { API_URL } from "./../const";

export const searchCourseByCouponCode = async (couponCode) => {
    let headers = {
        "Content-Type": "application/json",
    };

    const token = localStorage.getItem("access");
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    try {
        const response = await fetch(
            `${API_URL}/api/v1/search-coupons/${couponCode}`,
            {
                method: "GET",
                headers,
            }
        );
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.error || "Request failed");
        }

        const { courses, warning } = data;
        return { courses, warning };
    } catch (error) {
        throw error;
    }
};